import { Component, OnInit } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../../shared/components/api-operable/api-operable.component';
import { UIActiveDialogService } from '../../../../../shared/services/ui-dialog.service';
import { DataTableUtils } from '../../../../../shared/utils/data-table.utils';
import { AuthService } from '../../../../security/service/auth.service';
import { PartsService } from '../../../service/parts.service';

@Component({
  selector: 'app-parts-supplier-parts-manage-dialog',
  templateUrl:
    './console/app-js/modules/parts/components/parts-supplier-parts/parts-supplier-parts-manage-dialog/parts-supplier-parts-manage-dialog.component.html'
})
export class PartsSupplierPartsManageDialogComponent
  extends APIOperableComponent
  implements OnInit {
  private suppliers = [];
  public suppliersFiltered = [];
  public filterValue = '';
  public loading = false;
  public selection = [];
  public selectedSuppliers: Array<any>;
  public sku: string;
  public cost: string;
  public costError = false;

  constructor(
    currentSuppliers: Array<any>,
    toastr: ToastrService,
    progressService: NgProgress,
    authService: AuthService,
    public partsService: PartsService,
    private activeDialog: UIActiveDialogService
  ) {
    super(progressService, toastr, authService);
    this.selectedSuppliers = [...currentSuppliers];
  }

  ngOnInit() {
    this.loading = true;
    this.partsService.getSuppliers().subscribe(res => {
      // filter out suppliers that are already there
      this.suppliers = res.filter(item => {
        return !this.selectedSuppliers.find(
          selectedItem => selectedItem.supplierId === item.id
        );
      });
      this.suppliersFiltered = this.suppliers;
      this.loading = false;
    });
  }

  public onClearFilter(): void {
    this.filterValue = '';
    this.onFilterData();
  }

  public onFilterData(): void {
    this.suppliersFiltered = DataTableUtils.filterDataByProperty(
      this.suppliersFiltered,
      this.suppliers,
      this.filterValue,
      'name'
    );
  }

  public onSave() {
    this.activeDialog.close({
      supplierId: this.selection[0].id,
      sku: this.sku,
      cost: this.cost
    });
  }

  public onClose(): void {
    this.activeDialog.dismiss();
  }

  public onKeyup() {
    if (this.cost && this.cost !== '') {
      let left = this.cost.split('.')[0];
      let right = this.cost.split('.')[1];
      if (left && left.length > 8) {
        this.costError = true;
      } else {
        this.costError = false;
      }
      if (right) {
        if (right.length > 2) {
          this.costError = true;
        } else if (!(left && left.length > 8)) {
          this.costError = false;
        }
      }
    }
  }
}
